export default "__VITE_ASSET__BGO4Q2fC__"